import {withComponent} from '../../hoc/withComponent';
import {TableCellBase} from './TableCellBase';

export const withTableCell = withComponent(TableCellBase);
